import { BotaoAcoesType } from '@/shared/components/layout/botao-acoes/botao-acoes';
import { Component, OnInit, output } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
    template: ''
})
export abstract class ActionChildComponent implements OnInit {
    emitActions = output<BotaoAcoesType & { useEdit: boolean }>();
    toggleableNames = new Set<string>();

    abstract initComponent(): void;
    abstract getDefinedActions(): BotaoAcoesType & { useEdit: boolean };
    abstract updateActionsWithIndexes(actions: [MenuItem, number][]): void;
    abstract toggleAction(action: MenuItem): MenuItem;

    setToggleableActions(actionsSet: Set<string>): void {
        this.toggleableNames = actionsSet;
    }

    ngOnInit(): void {
        this.emitActions.emit(this.getDefinedActions());
        this.initComponent();
    }

    updateActions() {
        const actions = this.getToggleableActions();
        const updated: [MenuItem, number][] = [];
        for (let toggleable of actions) {
            updated.push(this.updateDisabledState(toggleable));
        }
        this.updateActionsWithIndexes(updated);
    }

    private getToggleableActions(): [MenuItem, number][] {
        return this.getDefinedActions()
            .items.map((item, ind) => [item, ind] as [MenuItem, number])
            .filter(([action, _ind]: [MenuItem, number]) => this.toggleableNames.has(action.label ?? ''));
    }

    private updateDisabledState([action, ind]: [MenuItem, number]): [MenuItem, number] {
        const updatedAction = this.toggleAction(action);
        return [updatedAction, ind];
    }
}
